export const prices = [
  {
    _id: 0,
    name: 'Any',
    array: [],
  },
  {
    _id: 1,
    name: 'RS-750 to RS-900',
    array: [0, 9],
  },
  {
    _id: 2,
    name: 'RS-1500 to RS-2500',
    array: [10, 19],
  },
  {
    _id: 3,
    name: 'RS-1600 to RS-3000',
    array: [20, 29],
  },
  {
    _id: 4,
    name: 'RS-2400 to RS-3299',
    array: [30, 39],
  },
  {
    _id: 5,
    name: 'More than 40',
    array: [40, 99],
  },
];
